import Cookies from 'js-cookie';

// Method to set data in cookies which will expire in 7 days
const setCookie = (key, data) => {
  Cookies.set(key, data, {
    expires: 7,
  });
};

// Method to get data from cookies
const getCookie = (key) => {
  return Cookies.get(key);
};

// Method to remove data from cookies
const removeCookie = (key) => {
  Cookies.remove(key);
};

export { setCookie, getCookie, removeCookie };
